// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved

import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import {
  Button,
  Spinner,
  FileUpload,
  DivisionSelect,
  KeyValueTable
} from '../../'

import {
  decodeBase64
} from '../../../utils'

import { FILETYPE_EMPLOYEE_CSV_IMPORT } from '../../../constants'


export class EmployeeCSVImporter extends React.Component {
  static propTypes = {
    employerId: PropTypes.string.isRequired
  }

  state = {
    division: null,
    fileUploadAndImportInProgress: false,
    fileSelected: false,
    uploadedFileId: null,
    importReportData: null
  }

  uploadCSVFile = () => {
    let file = document.getElementById('file-input').files[0]
    let reader = new FileReader()
    let headers = new Headers({
      'Authorization': 'Token ' + localStorage.getItem('token') || null
    })

    let data = new FormData()
    data.append('file', file)
    data.append('filetype', FILETYPE_EMPLOYEE_CSV_IMPORT)

    reader.onload = (e) => {
      fetch(`${process.env.REACT_APP_API_ROOT}/v1/file/`, {
        method: 'post',
        headers: headers,
        body: data
      })
      .then(response => {
        if (response.ok) {  // covers 200-range of http responses
          console.info("File uploaded")
          response.json()
            .then(data => this.setState({ uploadedFileId: decodeBase64(data.file) }))
        } else {
          console.error("File upload failed")
          this.setState({ fileUploadAndImportInProgress: false })
        }
      })
      .catch(error => {
        console.error(`File upload failed - ${error}`)
        this.setState({ fileUploadAndImportInProgress: false })
      })
    }

    reader.readAsText(file)

    return file
  }

  importCSVFile = (file) => {
    let data = new FormData()
    data.append('file', file)

    fetch(`${process.env.REACT_APP_API_ROOT}/v1/import_employees/${decodeBase64(this.state.division)}/`, {
      method: 'post',
      body: data
    })
    .then(response => {
      if (response.ok) {
        return response.json()
          .then(data => this.setState({ importReportData: data["import_report"] }))
      }
    })
    .then(() => this.setState({ fileUploadAndImportInProgress: false }))
  }

  uploadAndImportCSVFile = () => {
    this.setState({ fileUploadAndImportInProgress: true })

    let file = this.uploadCSVFile()
    this.importCSVFile(file)
  }

  handleInputValueChange = (e) => {
    let field = e.target.id
    this.setState({ [field]: e.target.value })
  }

  render() {
    const { employerId } = this.props
    const { division, fileUploadAndImportInProgress, fileSelected, importReportData } = this.state

    return (
      <div>
        {importReportData === null
          ? <Fragment>
              <div>
                First, choose the division employees belong to
                <DivisionSelect
                  id='division'
                  employer={employerId}
                  value={division}
                  onChange={this.handleInputValueChange}
                  className='slds-m-bottom_small'
                />
                {division &&
                  <div className='slds-m-top_x-small'>
                    Then select the CSV (comma-separated values) file containing the employee records you want to import.
                    <p className='slds-m-top_x-small'>
                      * Please ensure that the first line, the column headers, of your file matches:
                      <br />
                      <i className='slds-text-color_weak'>
                        First name,Last name,Other name,ID number,Primary phone number,Additional phone numbers,Employment type,Employee number
                      </i>
                    </p>
                  </div>
                }
              </div>
              {division &&
                <FileUpload
                  endpoint='/v1/file/'
                  filetype={null}
                  fileRelationships={[]}
                  noUploadButton={true}
                  sldsStyle={true}
                  onFileSelect={() => this.setState({ fileSelected: true })}
                />
              }
              <Button
                type='brand'
                minWidth={120}
                onClick={this.uploadAndImportCSVFile}
                disabled={!fileSelected}
                className='slds-m-top_large'>
                {fileUploadAndImportInProgress
                  ? <Spinner type='brand' size='small' className='slds-relative' />
                  : 'Import employees'
                }
              </Button>
            </Fragment>
          : <div>
              <KeyValueTable
                heading='Import Report'
                data={importReportData}
                keyColumnSize='3-of-4'
              />
            </div>
        }

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/messageplus/employee-csv-importer/index.js